import Decimal from 'decimal.js';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { add, Money } from '../../../utils/money';
import { IOrderDeliveryTask, IPickupTask } from '../../../interfaces/delivery-company/tasks';
import { OrderDeliveryTaskState } from '../../../enums/tasks';

export const compute_total_price = (orders: OrderType[]): Money[] => {
  let total_price: Money[] = [];
  orders.forEach((order) => {
    total_price = add(total_price, order.price);
  });
  return total_price;
};

export const compute_total_delivery_fee = (orders: OrderType[]): Money[] => {
  let total_delivery_fee: Money[] = [];
  orders.forEach((order) => {
    total_delivery_fee = add(total_delivery_fee, order.delivery_fee);
  });
  return total_delivery_fee;
};

export const compute_total_driver_commission = (
  orders: OrderType[]
): Money[] => {
  let total_driver_commission: Money[] = [];
  orders.forEach((order) => {
    total_driver_commission = add(
      total_driver_commission,
      order.driver_commission
    );
  });
  return total_driver_commission;
};

export const compute_total_driver_commission_from_delivery_tasks = (
  tasks: IOrderDeliveryTask[]
): Money[] => {
  let total_driver_commission: Money[] = [];
  tasks.forEach((task) => {
    total_driver_commission = add(
      total_driver_commission,
      task.status == OrderDeliveryTaskState.COMPLETED ? task.driver_commission : task.failed_delivery_commission
    );
  });
  return total_driver_commission;
};

export const compute_total_pickup_commission = (
  tasks: IPickupTask[]
): Money[] => {
  let total_driver_commission: Money[] = [];
  tasks.forEach((task) => {
    total_driver_commission = add(
      total_driver_commission,
      task.driver_commission
    );
  });
  return total_driver_commission;
};

export const compute_total_cod = (orders: OrderType[]): Money[] => {
  let total_cod: Money[] = [];
  orders.forEach((order) => {
    total_cod = add(total_cod, add(order.price, order.delivery_fee));
  });
  return total_cod;
};

export const compute_total_pop = (orders: OrderType[]): Money[] => {
  let total_pop: Money[] = [];
  orders.forEach((order) => {
    total_pop = add(total_pop, order.pop);
  });
  return total_pop;
};
